import http from "./http-common";

class LoginService {
    getAppInfo(id) {
        return http.get('appInfo');
    }
    keepServerAwake(){
      return  http.get('wakeUp');
    }
    login(param) {
      const body = Object.keys(param).map(k => encodeURIComponent(k) + "=" + encodeURIComponent(param[k])).join("&");
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'text',
        body:body
      };
     return fetch('login', requestOptions);
    }
}

export default new LoginService();